import React from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import CreateIcon from '@mui/icons-material/Create';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';
import { Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import { administration_types } from '../../../helper/constants.helper';
import { useStoreState } from 'easy-peasy';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';

const AssessmentDetails = ({ assessment }) => {
  const { assessmentSlug } = useParams();
  const user = useStoreState((state) => state.user);
  const navigate = useNavigate();

  const navigateToCheckout = () => {
    if (user) {
      navigate(`/assessments/${assessmentSlug}/checkout`);
    } else {
      toast.error('Please login to start assessment');
      navigate('/login');
    }
  };

  return (
    <>
      <div className="assessment-details">
        <p className="margin-top--lg">
          Use this self-assessment to reflect, gain insight, and better understand yourself.
        </p>
        <h1 className="title margin-top--sm"> {assessment?.name}</h1>
        <div className="flex-container margin-top--md">
          <DescriptionIcon fontSize="small" color="primary" />
          <p style={{ margin: '-2px 0px 0px 5px' }}>{assessment?.short_title}</p>
        </div>
        <div className="flex-container margin-top--sm">
          <RecommendOutlinedIcon fontSize="small" color="primary" />
          <p style={{ margin: '-1px 0px 0px 5px' }}>{assessment?.eligibility}</p>
        </div>
        <div className="flex-container margin-top--sm">
          <HourglassEmptyIcon fontSize="small" color="primary" />
          <p style={{ margin: '-1px 0px 0px 5px' }}>{assessment?.duration}</p>
        </div>
        <div className="flex-container margin-top--sm">
          <CreateIcon fontSize="small" color="primary" />
          <p style={{ margin: '-1px 0px 0px 5px' }}>
            {assessment?.administrations
              ?.map((administration) => administration_types[administration])
              .filter(Boolean)
              .join(', ')}
          </p>
        </div>
        <Button
          variant="contained"
          fullWidth
          style={{ maxWidth: '200px', marginTop: '40px' }}
          size="large"
          onClick={() => navigateToCheckout()}>
          Start assessment
        </Button>
        {assessment?.shareReport ? (
          <p className="margin-top--md">
            <LockOpenTwoToneIcon
              style={{ color: 'green', marginBottom: '-4px', fontSize: '20px' }}
            />
            <small style={{ marginLeft: '8px' }}>Report shared with you</small>
          </p>
        ) : (
          <p className="margin-top--md">
            <LockIcon style={{ color: 'red', marginBottom: '-4px', fontSize: '20px' }} />
            <small style={{ marginLeft: '8px' }}>
              Report shared with therapist only - not visible to you
            </small>
          </p>
        )}
      </div>
      <style jsx>{`
        .assessment-details {
          padding-right: 20px;
          width: 50%;
        }
        .title {
          font-weight: 600;
        }
        @media only screen and (max-width: 768px) {
          .assessment-details {
            padding-right: 0px;
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default AssessmentDetails;
